export enum Routes {
  Committees = "/Committees",
  CommitteesView = "/CommitteesView",
  OpenCommitteesView = "/OpenCommitteesView",
  CommitteeApplication = "/CommitteeApplication",
  Meetings = "/Meetings",
  HtmlAgenda = "/HtmlAgenda",  
  PublicNotices = "/PublicNotices",
  OpenPositions = "/OpenPositions",
  Unauthorized = "/Unauthorized",  
}
